import React, { useContext, Fragment, useEffect } from 'react'
import { useLazyQuery, gql, NetworkStatus } from '@apollo/client'
import { CartChangeFiltersContext } from '../../../../context/CartChangeFiltersContext'
import AutocompleteComponent from '../../../../components/filters/AutocompleteComponent'

export const GET_CITIES_EVENT_CART_CHANGE = gql`
  query GetCitiesEventCartChange($filters: EventCartChangeFilter) {
    eventCartChangeAggs(
      filters: $filters,
      index: "eventos-fapp-cart-change-*",
      size: 0,
      aggs: {
        cities: {
          terms: {
            field: "geoip.city_name.keyword",
            size: 400,
            order: {
              _key: "asc"
            }
          }
        }
      }
    ) {
      aggregations
    }
  }
`

export default function Cities (): JSX.Element {
  const { filters, setFilters } = useContext(CartChangeFiltersContext)
  const [getData, { loading, error, data, networkStatus }] = useLazyQuery(
    GET_CITIES_EVENT_CART_CHANGE, {
      notifyOnNetworkStatusChange: true
    }
  )

  useEffect(() => {
    const { date, geoipStates } = filters
    getData({
      variables: { filters: { date, geoipStates } }
    })
  }, [filters])

  if (networkStatus === NetworkStatus.refetch) return <p>Refetching!</p>
  if (loading || !data) return <p>Loading!</p>
  if (error) return <p>Error :(</p>
  if (!data.eventCartChangeAggs.aggregations.cities) return <p>No data found</p>

  const cities: Array<string> = []
  data.eventCartChangeAggs.aggregations.cities.buckets.map((city: any) => {
    cities.push(city.key)
  })

  const onChange = (value: any) => {
    setFilters({
      geoipCities: value
    })
  }
  const typographLabel = 'Município'

  return (
    <Fragment>
      <AutocompleteComponent
        labelValue={typographLabel}
        data={cities}
        defaultValues={filters.geoipCities}
        onChange={onChange}
      />
    </Fragment>
  )
}
